import z from 'zod'
import { UserRole } from '@/core/domain/resources/enums/UserRole'
import { UserBirthdateSchema } from '@/core/infrastructure/schemas/utils/UserBirthdateSchema.ts'
import { UserIdentifierSchema } from '@/core/infrastructure/schemas/utils/UserIdentifierSchema.ts'
import { UserEmailSchema } from '@/core/infrastructure/schemas/utils/UserEmailSchema.ts'
import { UserGenderSchema } from '@/core/infrastructure/schemas/utils/UserGenderSchema.ts'
import { UserListRolesSchema } from '@/core/infrastructure/schemas/utils/UserListRolesSchema.ts'
import { capitalize } from 'vue'

const EmbeddedUserSchema = z.object({
  identifier: UserIdentifierSchema,
  firstname: z.string(),
  lastname: z.string(),
  username: z.string(),
  roles: UserListRolesSchema,
  email: UserEmailSchema,
  gender: UserGenderSchema,
  birthdate: UserBirthdateSchema.optional(),
  createdAt: z.string().datetime().nullable(),
  modifiedAt: z.string().datetime().nullable()
})

export const SchoolPeriodUserSchema = z.object({
  schoolPeriodUserId: z.number(),
  user: EmbeddedUserSchema,
  hasSignedAgreement: z.boolean().nullish()
})

export const SchoolPeriodUserListSchema = z.array(SchoolPeriodUserSchema)

export const SchoolPeriodUserInputSchema = z.object({
  identifier: UserIdentifierSchema.optional(),
  firstname: z.string().trim().min(1, 'Le prénom est requis').max(150, 'Le prénom est trop long').transform((value) => capitalize(value)),
  lastname: z.string().trim().toUpperCase().min(1, 'Le nom est requis').max(150, 'Le nom est trop long'),
  email: UserEmailSchema,
  birthdate: UserBirthdateSchema.nullable(),
  roles: z.array(z.nativeEnum(UserRole.SchoolValues)),
  gender: UserGenderSchema,
  schoolPeriodId: z.number(),
  hasSignedAgreement: z.boolean().nullish()
})

export type SchoolPeriodUserEntity = z.infer<typeof SchoolPeriodUserSchema>
export type SchoolPeriodUserListEntity = z.infer<typeof SchoolPeriodUserListSchema>
export type SchoolPeriodUserInputEntity = z.infer<typeof SchoolPeriodUserInputSchema>
